import React, {Component} from 'react';
// import ReactDOM from 'react-dom';
import './Card.css';
import Fade from 'react-reveal/Fade';
import RubberBand from 'react-reveal/RubberBand';
import Modal from 'react-responsive-modal';
import renderHTML from 'react-render-html';
import LazyLoad from 'react-lazy-load';

class Cards extends Component {
  componentDidMount() {
    const tempCardData = this.state.cardData;
    tempCardData.sort(function (a, b) {
      return a.order - b.order;
    });
    this.setState({ cardData: tempCardData });
  }

  constructor(props) {
    super(props);
    this.state = {
      cardData: props.cardData,
      modal_open: false,
      modal_content: '',
      modal_title: ''
    };

    this.handleClick = this.handleClick.bind(this);
    this.onEnterModal = this.onEnterModal.bind(this);
    this.onOpenModal = this.onOpenModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);

    this.modalContainerRef = React.createRef();
    this.modalOpenRef = [];
  }

  handleClick = card => {
    card.open_status = !card.open_status;
    this.setState({ cardData: this.props.cardData });
    if (card.open_status) {
      this.setState({
        modal_card: card,
        modal_content: card.expanded_html,
        modal_title: card.aria_label
      });
      this.onOpenModal();
    }
  }

  onEnterModal = () => {
    // focus the modal content when modal is open
    this.modalContainerRef.current.children[0].children[0].children[0].focus();
  }

  onOpenModal = () => {
    this.setState({ modal_open: true });
  }

  onCloseModal = () => {
    // round about way to set the open_status back to false
    // when a modal is closed
    const modalCard = this.state.modal_card;
    const tempCardData = this.state.cardData;
    tempCardData[modalCard.id - 1].open_status = false;
    this.setState({ cardData: tempCardData, modal_open: false });
    // set focus back to the card button it came from
    this.modalOpenRef[modalCard.id].focus();
  }

  render() {
    const cardItems = this.props.cardData.map((card, index) => {
      let cardStyles = {
        background: 'url(' + card.image + ')',
        backgroundColor: card.background_color,
        backgroundSize: 'cover',
        backgroundPosition: '50% 50%',
        color: card.color
      }

      let cardImageContent = '';

      if (card.type === 'image-content') {
        // cardStyles= {
        //   background: 'url(' + card.image + ')',
        //   backgroundColor: card.background_color,
        //   backgroundSize: '41rem',
        //   backgroundPosition: '68% 0%',
        //   backgroundRepeat: 'no-repeat',
        //   color: card.color
        // };
        cardStyles = {
          backgroundColor: card.background_color,
          color: card.color
        };

        cardImageContent = '<div class="Card-stack-container"><div class="Card-stack-image" style="background-image: url(' + card.image + '); background-size: cover; background-repeat: no-repeat; background-position: 50% 50%; width: 100%;"></div></div>';
      }

      let buttonStyles = {};

      if (!card.has_expanded_html) {
        buttonStyles = { display: 'none' };
      }

      let cardImageSize = 0;

      if (card.size === '1x1') {
        cardImageSize = 368;
      } else if (card.size === '2x1' && window.innerWidth < 768) {
        cardImageSize = 800;
      } else if (card.size === '2x1' && window.innerWidth >= 768 && window.innerWidth < 1232) {
        cardImageSize = 752;
      } else if (card.size === '2x1' && window.innerWidth >= 1232) {
        cardImageSize = 800;
      } else if (card.size === '2x2' && window.innerWidth < 768) {
        cardImageSize = 368;
      } else if (card.size === '2x2' && window.innerWidth >= 768 && window.innerWidth < 1232) {
        cardImageSize = 752;
      } else if (card.size === '2x2' && window.innerWidth >= 1232) {
        cardImageSize = 800;
      }

      return (
        <div key={ card.id } id={ 'Card--' + (card.id) } className={ 'Card Card--' + (card.id) + ' Card--' + card.type + ' ' + ((card.open_status) ? 'Card--focused' : 'Card--not-focused')}>
          <LazyLoad debounce={ false } throttle={ 100 } height={ cardImageSize } offsetVertical={ 1080 }>
            <Fade bottom delay={ 100 + (250 * Math.random()) }>
              <div className={ 'Card-container' } style={ cardStyles }>
                <RubberBand top delay={ 1500 + (1000 * Math.random()) }>
                  <button ref={ modal => this.modalOpenRef[card.id] = modal } aria-label={ 'Open for more information about card ' + card.id } style={ buttonStyles } className="modal-open-button" onClick={ e => this.handleClick(card) }><svg className="modal-open-icon" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 36 36"><path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"></path></svg></button>
                </RubberBand>
                <div className="Card-blurb">
                  <div className={ 'Card-blurb-container Card-blurb-container--' + card.blurb_placement }>
                    <div className="Card-stack">{ renderHTML(cardImageContent) }</div>
                    <div className="Card-blurb-title">{ renderHTML(card.title) }</div>
                    <div className="Card-blurb-excerpt">{ renderHTML(card.excerpt) }</div>
                  </div>
                </div>
              </div>
            </Fade>
          </LazyLoad>
        </div>
      );
    });

    return (
      <div>
        <div className="Card-list">
          <div className="Card-list-container">
            { cardItems }
          </div>
        </div>

        <div ref={ this.modalContainerRef } className="modal-container">
          <Modal onEntered={ this.onEnterModal } container={ this.modalContainerRef.current } classNames={ { closeButton: 'modal-close-button', closeIcon: 'modal-close-icon', modal: 'modal', overlay: 'modal-overlay' } } closeIconSize={ 56 } open={ this.state.modal_open } onClose={ this.onCloseModal } animationDuration={ 200 } center>
            <div className="modal-content" aria-label={ this.state.modal_title } aria-modal="true" role="dialog" tabIndex="-1">
              <div className="modal-content-container">
                { renderHTML(this.state.modal_content) }
              </div>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}

export default Cards;


// WEBPACK FOOTER //
// ./src/components/Cards/Cards.js